// Audit: zahájení, probíhající audit, opatření při auditu.
// (Krok B1b: rozděleno ze src/app.js beze změny kódu; importy/exporty doplněny automaticky.)
import { appearance } from '../core/appearance.js';
import { auditGroupPickHtml, sortedAuditGroups, typesInGroup, ICONS, SCHEDULE_START_WINDOW_DEFAULT, SCORE_FACTORY_DEFAULT, branchLabel, canWriteAudits, defaultNokThreshold, esc, fmtDateShort, fmtOccurrenceDate, groupWorkplacesByBranch, groupsForType, auditWorkplaceIds, isCoAuditor, isMyOpenAudit, myRole, nextAuditNumberForCompany, normalizeSearchText, openAudits, roleHasCompany, questionCountForType, questionsInGroup, queueWrite, showToast, sortedAuditTypes, sortedWorkplaces, state, subQuestionsInQuestion, uid, workplacesLabel, auditAuditorLabel, OPEN_AUDIT_TTL_HOURS, openAuditTtlHours, openAuditRemainingMs, openAuditRemainingText, workplaceLabel } from '../core/state.js';
import { paginateList, paginationControlsHtml } from '../core/pagination.js';
import { assetsCap, db } from '../core/boot.js';
import { confirmRow } from '../core/chrome.js';
import { EXTERNAL_RESPONSIBLE, externalResponsibleFieldsHtml, responsibleLabelHtml, responsibleUserOptionsHtml, responsiblePersonForWorkplace, userNameById } from './places.js';
import { auditTypeFullCode, auditTypeMissingCodeMsg } from '../core/access.js';
import { correctiveCodeHtml, correctiveCodeOf, correctiveKey, correctiveStatusBadgeHtml } from './corrective.js';
import { allVisibleScheduleOccurrences, personDisplayName, scheduleListWindow, scheduleOccurrenceBadgeHtml } from './schedule.js';
import { dateTimeInputHtml, render } from '../main-render.js';
import { settingsTabsHtml } from '../core/ui-kit.js';
import { guardWrite, uploadErrorText } from '../core/licence.js';

// ================= AUDIT (runner) =================
function buildAnswersSnapshot(typeId){
  var answers = [];
  groupsForType(typeId).forEach(function(ge){
    var gid = ge[0], g = ge[1];
    questionsInGroup(gid).forEach(function(qe){
      var qid = qe[0];
      answers.push({
        id: uid('a'),
        questionId: qid,
        groupId: gid,
        groupName: g.name,
        questionText: qe[1].text,
        result: null,
        note: '',
        attachments: [],
        subAnswers: subQuestionsInQuestion(qid).map(function(se){
          return {
            id: uid('sa'),
            subQuestionId: se[0],
            text: se[1].text,
            result: null,
            note: '',
            attachments: []
          };
        })
      });
    });
  });
  return answers;
}
// ---------- Audity: záložky Rozpracované / K zahájení / Uzavřené ----------
// Rozpracované a K zahájení jsou obrazovka 'audit' (state.auditTab),
// Uzavřené = Historie (state.view 'history'). Rozhodnutí uživatele 2026-10-28.
// Jen moje rozpracované audity a ty, kde jsem spoluauditor — cizí nevidí
// nikdo, ani Administrátor (rozhodnutí uživatele 2026-11-01; opuštěné cizí
// audity po lhůtě smaže expire-open-audits).
function visibleOpenAudits(){
  return openAudits().filter(function(e){ return isMyOpenAudit(e[1]) || isCoAuditor(e[1]); });
}
// Bez zvolené záložky: Rozpracované, pokud nějaký mám, jinak K zahájení.
function effectiveAuditTab(){
  if(state.auditTab==='open' || state.auditTab==='start') return state.auditTab;
  return openAudits().some(function(e){ return isMyOpenAudit(e[1]); }) ? 'open' : 'start';
}
function auditsHeadHtml(current){
  var tabs = [];
  if(canWriteAudits()){
    var n = visibleOpenAudits().length;
    tabs.push(['open', 'Rozpracované', n ? ' ('+n+')' : '']);
    tabs.push(['start', 'K zahájení']);
  }
  tabs.push(['closed', 'Uzavřené']);
  return '<div class="view-head"><h2>Audity</h2></div>' + settingsTabsHtml(tabs, current, 'App.setAuditTab');
}
// Z navigace a odkazů: Audity na dané záložce (bez ní podle effectiveAuditTab).
App.openAudits = function(tab){
  if(!canWriteAudits()){ App.setView('history'); return; }
  state.auditTab = tab || null;
  if(state.auditTab==null) state.auditTab = effectiveAuditTab();
  App.setView('audit');
};
App.setAuditTab = function(tab){
  if(tab==='closed'){ App.setView('history'); return; }
  state.auditTab = tab;
  if(state.view!=='audit') App.setView('audit');
  else render();
};
function renderAudit(){
  if(state.activeAuditId && state.draftAudit){
    renderAuditRunner();
    return;
  }
  var tab = effectiveAuditTab();
  var html = auditsHeadHtml(tab);

  // Rozpracované audity: každý vidí jen své; Administrátor navíc cizí,
  // ale jen se možností smazat (pokračovat v cizím auditu nesmí nikdo).
  var oa = visibleOpenAudits();
  if(tab==='open' && oa.length===0){
    html += '<div class="empty">'+ICONS.empty+'<p>Nemáte žádný rozpracovaný audit.</p>' +
      '<p style="margin-top:10px"><button class="btn btn-primary" onclick="App.openAudits(\'start\')">Zahájit audit</button></p></div>';
    document.getElementById('content').innerHTML = html;
    return;
  }
  if(tab==='open'){
    var oaPage = paginateList(oa, 'auditOpenPage');
    html += '<div class="card" style="margin-bottom:16px">';
    oaPage.items.forEach(function(e,i){
      var id=e[0], a=e[1];
      var answered = (a.answers||[]).filter(function(x){return x.result;}).length;
      var total = (a.answers||[]).length;
      var progressTxt = isFindingsTypeId(a.auditTypeId) ? findingsCountText(a.findings) : answered+'/'+total+' zodpovězeno';
      var cConfirm = confirmRow('cancelaudit:'+id, 'Zrušit tento rozpracovaný audit? Odpovědi se ztratí.', 'Zrušit audit', 'btn-danger');
      html += (i>0?'<div class="list-sep"></div>':'');
      if(cConfirm){
        html += '<div><div style="font-weight:600;font-size:var(--fs-md);margin-bottom:6px">'+esc(a.workplaceName)+'</div>' + cConfirm + '</div>';
      } else {
        html += '<div class="row-between"><div><div style="font-weight:600;font-size:var(--fs-md)">'+esc(a.workplaceName)+'</div>' +
          '<div class="muted" style="font-size:var(--fs-sm)">'+esc(a.branchName||'Sídlo firmy')+'</div>' +
          '<div class="muted" style="font-size:var(--fs-sm)">'+esc(a.auditTypeName||'Audit')+' · '+esc(auditAuditorLabel(a))+' · '+fmtDateShort(a.startedAt)+' · '+progressTxt+'</div>' +
          '<div style="font-size:var(--fs-sm);margin-top:2px;'+(openAuditRemainingMs(a)<2*3600000?'color:var(--nok);font-weight:600':'color:var(--fg-muted)')+'">Dokončit do '+openAuditTtlHours()+' h od zahájení · '+openAuditRemainingText(a)+'</div></div>' +
          '<div style="display:flex;gap:6px;flex-shrink:0">' +
          (isMyOpenAudit(a) ? '<button class="icon-btn" title="Zrušit audit" onclick="App.askConfirm(\'cancelaudit:'+id+'\', function(){App.cancelAudit(\''+id+'\')})">'+ICONS.trash+'</button>' : '') +
          (isMyOpenAudit(a) ? '<button class="btn btn-sm btn-primary" onclick="App.resumeAudit(\''+id+'\')">Pokračovat</button>' :
            '<span class="badge badge-neutral" style="align-self:center">Spoluauditor</span>') +
          '</div></div>';
      }
    });
    html += '</div>';
    html += paginationControlsHtml('auditOpenPage', oaPage);
    document.getElementById('content').innerHTML = html;
    return;
  }

  var types = sortedAuditTypes();
  if(types.length===0){
    html += '<div class="empty">'+ICONS.empty+'<p>Nejprve vytvořte alespoň jeden druh auditu s otázkami.</p>' +
      '<p style="margin-top:10px"><button class="btn btn-primary" onclick="App.setView(\'questions\')">Přejít na druhy auditů</button></p></div>';
    document.getElementById('content').innerHTML = html;
    return;
  }
  var wps = sortedWorkplaces();
  if(wps.length===0){
    html += '<div class="empty">'+ICONS.empty+'<p>Nejprve přidejte alespoň jedno pracoviště.</p>' +
      '<p style="margin-top:10px"><button class="btn btn-primary" onclick="App.setView(\'branding\')">Přejít na pracoviště</button></p></div>';
    document.getElementById('content').innerHTML = html;
    return;
  }

  var branchGroups = groupWorkplacesByBranch();
  if(state.newAuditBranch===null || !branchGroups.some(function(g){ return g.branchId===state.newAuditBranch; })){
    state.newAuditBranch = branchGroups[0].branchId;
  }
  var wpsInBranch = (branchGroups.filter(function(g){ return g.branchId===state.newAuditBranch; })[0]||{items:[]}).items;
  // Řetěz Pracoviště → Podřízené pracoviště (2026-11-03): state.newAuditWp = vybrané
  // (nadřazené, nebo jeho podřízené); seznam pracovišť jen první úrovně.
  var isTopWp = function(e){ return !e[1].parentId || !state.workplaces.has(e[1].parentId); };
  var topsInBranch = wpsInBranch.filter(isTopWp);
  var selWpObj = state.workplaces.get(state.newAuditWp);
  var topWpId = selWpObj && selWpObj.parentId && state.workplaces.has(selWpObj.parentId) ? selWpObj.parentId : state.newAuditWp;
  if(!topWpId || !topsInBranch.some(function(e){ return e[0]===topWpId; })){
    topWpId = (topsInBranch[0]||[])[0] || '';
    state.newAuditWp = topWpId;
  }
  var subWps = wpsInBranch.filter(function(e){ return e[1].parentId===topWpId; });
  var subWpId = subWps.some(function(e){ return e[0]===state.newAuditWp; }) ? state.newAuditWp : '';
  // Nejdřív skupina auditů, pak druh jen z ní (rozhodnutí uživatele 2026-10-31).
  if(state.newAuditGroup && sortedAuditGroups().indexOf(state.newAuditGroup)<0) state.newAuditGroup = '';
  var groupTypes = typesInGroup(types, state.newAuditGroup || '');
  if(!groupTypes.length) groupTypes = types;
  if(!state.newAuditType || !groupTypes.some(function(e){ return e[0]===state.newAuditType; })){ state.newAuditType = groupTypes[0][0]; }
  var selTypeQ = questionCountForType(state.newAuditType);
  var selFindings = isFindingsTypeId(state.newAuditType);
  // Obchůzka: víc pracovišť najednou (zaškrtávátka); výchozí = vybrané pracoviště.
  var branchWpIds = wpsInBranch.map(function(e){ return e[0]; });
  // výchozí výběr jen poprvé a po změně provozovny („Zrušit vše“ nechá prázdné)
  var newWps;
  if(!state.newAuditWps || state.newAuditWpsBranch!==state.newAuditBranch) newWps = state.newAuditWp ? [state.newAuditWp] : [];
  else newWps = state.newAuditWps.filter(function(id){ return branchWpIds.indexOf(id)>=0; });
  state.newAuditWps = newWps;
  state.newAuditWpsBranch = state.newAuditBranch;
  var wpFieldHtml = selFindings ?
    '<div class="field"><div class="row-between" style="align-items:baseline"><label>Pracoviště</label>' +
      (wpsInBranch.length>2 ? '<button type="button" class="link-btn" onclick="App.selectAllNewAuditWps('+(newWps.length===wpsInBranch.length?'false':'true')+')">'+(newWps.length===wpsInBranch.length?'Zrušit vše':'Vybrat vše')+'</button>' : '') + '</div>' +
      wpsInBranch.map(function(e){
        var child = !isTopWp(e);
        return '<label class="check-row'+(child?' check-row-child':'')+'"><input type="checkbox" '+(newWps.indexOf(e[0])>=0?'checked':'')+' onchange="App.toggleNewAuditWp(\''+e[0]+'\', this.checked)"><span>'+(child?'<span class="muted" aria-hidden="true">↳ </span>':'')+esc(e[1].name)+'</span></label>';
      }).join('') +
      '<div class="muted" style="font-size:var(--fs-sm);margin-top:5px">Obchůzka může projít víc pracovišť; u každého zjištění pak vyberete, na kterém bylo.</div></div>' :
    '<div class="field"><label>Pracoviště</label><select id="newAuditWp">' +
    topsInBranch.map(function(e){ return '<option value="'+e[0]+'" '+(topWpId===e[0]?'selected':'')+'>'+esc(e[1].name)+'</option>'; }).join('') +
    '</select></div>' +
    (subWps.length ? '<div class="field"><label>Podřízené pracoviště</label><select id="newAuditSubWp">' +
      '<option value="">— celé pracoviště —</option>' +
      subWps.map(function(e){ return '<option value="'+e[0]+'" '+(subWpId===e[0]?'selected':'')+'>'+esc(e[1].name)+'</option>'; }).join('') +
      '</select></div>' : '');

  var newAuditHtml = '<h3 class="set-section" style="margin-top:0">Nový audit</h3><div class="card" style="margin-bottom:16px">' +
    auditGroupPickHtml('newAuditGroup', state.newAuditGroup || '') +
    '<div class="field"><label>Druh auditu</label><select id="newAuditType">' +
    groupTypes.map(function(e){ return '<option value="'+e[0]+'" '+(state.newAuditType===e[0]?'selected':'')+'>'+esc(e[1].name)+(isFindingsType(e[1]) ? ' (obchůzka)' : ' ('+questionCountForType(e[0])+' ot.)')+'</option>'; }).join('') +
    '</select></div>' +
    (branchGroups.length>1 ?
      '<div class="field"><label>Provozovna</label><select id="newAuditBranch">' +
      branchGroups.map(function(g){ return '<option value="'+g.branchId+'" '+(state.newAuditBranch===g.branchId?'selected':'')+'>'+esc(g.label)+'</option>'; }).join('') +
      '</select></div>' : '') +
    wpFieldHtml +
    '<div class="field" style="margin-bottom:12px"><label for="ppInput_new">Zúčastněné osoby (nepovinné)</label>' +
    participantsPickerHtml('new') + '</div>' +
    (selFindings ? '<button class="btn btn-primary btn-block" onclick="App.startAudit()">Zahájit obchůzku</button>' :
    selTypeQ===0 ?
      '<div class="muted" style="font-size:var(--fs-base);margin-bottom:10px">Tento druh auditu zatím nemá žádné otázky.</div><button class="btn btn-primary btn-block" disabled>Zahájit audit</button>' :
      '<button class="btn btn-primary btn-block" onclick="App.startAudit()">Zahájit audit ('+selTypeQ+' otázek)</button>') +
    '</div>';

  var startableHtml = renderStartableSchedulesHtml();

  // Na desktopu jdou "Nový audit" a "Naplánované audity ke spuštění" vedle
  // sebe (formulář nalevo v pevném sloupci, seznam napravo vyplní zbytek)
  // — na mobilu/tabletu zůstávají pod sebou, jen s větší mezerou mezi nimi.
  html += '<div class="audit-form-row">' +
    '<div class="audit-form-col">' + newAuditHtml + '</div>' +
    (startableHtml ? '<div class="audit-startable-col">' + startableHtml + '</div>' : '') +
    '</div>';

  document.getElementById('content').innerHTML = html;

  var grSel = document.getElementById('newAuditGroup');
  if(grSel) grSel.addEventListener('change', function(){ state.newAuditGroup = grSel.value; state.newAuditType = ''; render(); });
  var brSel = document.getElementById('newAuditBranch');
  if(brSel) brSel.addEventListener('change', function(){ state.newAuditBranch = brSel.value; state.newAuditWp = ''; render(); });
  var wpSel = document.getElementById('newAuditWp');
  if(wpSel) wpSel.addEventListener('change', function(){ state.newAuditWp = wpSel.value; render(); });
  var subSel = document.getElementById('newAuditSubWp');
  if(subSel) subSel.addEventListener('change', function(){ state.newAuditWp = subSel.value || (wpSel && wpSel.value) || state.newAuditWp; });
  var typeSel = document.getElementById('newAuditType');
  if(typeSel) typeSel.addEventListener('change', function(){ state.newAuditType = typeSel.value; render(); });
}
App.toggleNewAuditWp = function(id, on){
  var list = (state.newAuditWps||[]).filter(function(x){ return x!==id; });
  if(on) list.push(id);
  state.newAuditWps = list;
  if(list.length) state.newAuditWp = list[0];
  render();
};
App.selectAllNewAuditWps = function(on){
  var g = groupWorkplacesByBranch().filter(function(x){ return x.branchId===state.newAuditBranch; })[0];
  state.newAuditWps = on && g ? g.items.map(function(e){ return e[0]; }) : [];
  render();
};
// Pracoviště obchůzky přes víc pracovišť (do auditu: workplaceIds + souhrnný název).
function multiWorkplaceFields(ids){
  var wps = ids.map(function(id){ return state.workplaces.get(id); }).filter(Boolean);
  var branches = {};
  wps.forEach(function(w){ branches[w.branchId||''] = true; });
  var oneBranch = Object.keys(branches).length===1;
  return {
    workplaceId: ids[0], workplaceIds: ids.slice(),
    workplaceName: workplacesLabel(wps.map(function(w){ return workplaceLabel(w); })),
    branchId: oneBranch ? (wps[0].branchId||'') : '', branchName: oneBranch ? branchLabel(wps[0].branchId) : 'Více provozoven'
  };
}
// Auditorem je vždy přihlášený účet — appka to nikdy nenechává vyplnit
// ručně (dřív šlo zadat jakékoliv jméno), aby bylo jasné, kdo audit
// skutečně provedl.
function currentAuditorName(){
  return personDisplayName(state.myId) || state.meName || state.meEmail || '';
}
App.startAudit = function(){
  if(!guardWrite()) return;
  var typeSel = document.getElementById('newAuditType');
  var wpId = state.newAuditWp || (sortedWorkplaces()[0]||[])[0];
  var typeId = typeSel ? typeSel.value : (sortedAuditTypes()[0]||[])[0];
  var people = participantPeople('new');
  var wp = state.workplaces.get(wpId);
  var type = state.auditTypes.get(typeId);
  var multiIds = isFindingsType(type) ? (state.newAuditWps||[]).filter(function(id){ return state.workplaces.has(id); }) : [];
  if(isFindingsType(type)){
    if(!multiIds.length){ showToast('Vyberte aspoň jedno pracoviště.'); return; }
    wpId = multiIds[0]; wp = state.workplaces.get(wpId);
  }
  if(!wp){ showToast('Vyberte pracoviště.'); return; }
  if(!type){ showToast('Vyberte druh auditu.'); return; }
  if(!db) return;
  var answers = isFindingsType(type) ? [] : buildAnswersSnapshot(typeId);
  if(answers.length===0 && !isFindingsType(type)){ showToast('Tento druh auditu nemá žádné otázky.'); return; }
  var startAuditCompanyId = wp.companyId || state.currentCompanyId || '';
  var startAuditCode = auditTypeFullCode(type);
  if(!startAuditCode){ showToast(auditTypeMissingCodeMsg(type)); return; }
  var data = {
    workplaceId: wpId, workplaceName: workplaceLabel(wp),
    branchId: wp.branchId || '', branchName: branchLabel(wp.branchId),
    companyId: startAuditCompanyId,
    auditCode: startAuditCode,
    auditNumber: nextAuditNumberForCompany(startAuditCompanyId, startAuditCode),
    auditTypeId: typeId, auditTypeName: type.name,
    auditorId: state.myId || null, auditorName: currentAuditorName(),
    participants: people.map(function(p){ return p.name; }),
    participantIds: people.filter(function(p){ return p.id; }).map(function(p){ return p.id; }),
    startedAt: new Date().toISOString(), closedAt: null,
    status: 'open', answers: answers, findings: [], summary: null
  };
  if(multiIds.length>1) Object.assign(data, multiWorkplaceFields(multiIds));
  queueWrite(function(){
    return db.collection('audits').add(data).then(function(ref){
      state.activeAuditId = ref.id;
      state.draftAudit = Object.assign({id:ref.id}, data);
      state.collapsedGroups = new Set();
      state.newAuditPeople = [];
      state.newAuditWps = null;
      state.view = 'audit';
      saveDraftBackup();
      render();
    });
  });
};
// ---------- naplánované audity, které může přihlášený uživatel zahájit ----------
// Zobrazí se jen termíny, kde je přihlášený uživatel vyřešeným auditorem
// (osoba přímo, nebo člen skupiny v rotaci — scheduleOccurrenceObjects to
// už rozbaluje), termín ještě nebyl splněn, a je buď po termínu, nebo
// max. 7 dní před ním (stejné okno jako e-mailové upozornění).
function isScheduleOccurrenceStartableNow(o){
  if(o.fulfilled || o.expired) return false; // po lhůtě „Neprovedeno“
  var windowDays = (typeof state.scheduleStartWindowDays==='number') ? state.scheduleStartWindowDays : SCHEDULE_START_WINDOW_DEFAULT;
  return o.date.getTime() <= Date.now() + windowDays*86400000;
}
function myStartableScheduledOccurrences(){
  if(!state.myId) return [];
  var w = scheduleListWindow();
  return allVisibleScheduleOccurrences(w.start, w.end).filter(function(o){
    return o.effectiveAuditorId===state.myId && isScheduleOccurrenceStartableNow(o);
  });
}
function renderStartableSchedulesHtml(){
  var list = myStartableScheduledOccurrences();
  if(!list.length) return '';
  var startablePage = paginateList(list, 'auditStartablePage');
  var html = '<h3 class="set-section" style="margin-top:0">Naplánované audity ke spuštění</h3><div class="card">';
  startablePage.items.forEach(function(o,i){
    html += (i>0?'<div class="list-sep"></div>':'');
    html += '<div class="list-item" style="align-items:flex-start;padding:2px">' +
      '<div style="min-width:0;flex:1">' +
      '<div style="font-weight:600;font-size:var(--fs-md)">'+esc(o.workplaceName)+'</div>' +
      '<div class="muted" style="font-size:var(--fs-sm)">'+esc(o.branchName||'Sídlo firmy')+' · termín '+fmtOccurrenceDate(o)+'</div>' +
      '<div class="muted" style="font-size:var(--fs-sm)">'+esc(o.scheduleName||o.auditTypeName||'Audit')+'</div>' +
      '</div>' +
      '<div style="display:flex;flex-direction:column;align-items:flex-end;gap:6px;flex-shrink:0">' +
      scheduleOccurrenceBadgeHtml(o) +
      '<button class="btn btn-sm btn-primary" onclick="App.startScheduledAudit(\''+o.key+'\')">Zahájit audit</button>' +
      '</div></div>';
  });
  html += '</div>';
  html += paginationControlsHtml('auditStartablePage', startablePage);
  return html;
}
App.startScheduledAudit = function(key){
  if(!guardWrite()) return;
  if(!db || !state.myId) return;
  var w = scheduleListWindow();
  var occ = allVisibleScheduleOccurrences(w.start, w.end).filter(function(o){ return o.key===key; })[0];
  if(!occ){ showToast('Tento termín už není k dispozici.'); render(); return; }
  if(occ.effectiveAuditorId!==state.myId){ showToast('Tento termín je určen jinému auditorovi.'); return; }
  if(occ.expired){ showToast('Lhůta pro provedení tohoto termínu uplynula.'); render(); return; }
  if(!isScheduleOccurrenceStartableNow(occ)){ showToast('Tento termín ještě nelze spustit.'); return; }
  var type = state.auditTypes.get(occ.auditTypeId);
  if(!type){ showToast('Druh auditu nenalezen.'); return; }
  var answers = isFindingsType(type) ? [] : buildAnswersSnapshot(occ.auditTypeId);
  if(answers.length===0 && !isFindingsType(type)){ showToast('Tento druh auditu nemá žádné otázky.'); return; }
  var wp = state.workplaces.get(occ.workplaceId) || {};
  var scheduledAuditCompanyId = occ.companyId || '';
  var scheduledAuditCode = auditTypeFullCode(type);
  if(!scheduledAuditCode){ showToast(auditTypeMissingCodeMsg(type)); return; }
  var data = {
    workplaceId: occ.workplaceId, workplaceName: occ.workplaceName,
    branchId: wp.branchId || '', branchName: occ.branchName,
    companyId: scheduledAuditCompanyId,
    auditCode: scheduledAuditCode,
    auditNumber: nextAuditNumberForCompany(scheduledAuditCompanyId, scheduledAuditCode),
    auditTypeId: occ.auditTypeId, auditTypeName: occ.auditTypeName,
    auditorId: state.myId, auditorName: currentAuditorName(),
    scheduleId: occ.scheduleId, scheduleOccurrenceDate: occ.dateStr,
    // zástup: provádí zástupce za auditora termínu
    delegatedFromId: occ.delegateId ? occ.auditorId : null, delegatedFromName: occ.delegateId ? occ.auditorName : '',
    // spoluauditoři plánu = zúčastněné osoby (docházku pak označí auditor)
    participants: (occ.coAuditorIds||[]).map(personDisplayName), participantIds: (occ.coAuditorIds||[]).slice(),
    startedAt: new Date().toISOString(), closedAt: null,
    status: 'open', answers: answers, findings: [], summary: null
  };
  if(occ.workplaceIds && occ.workplaceIds.length>1) Object.assign(data, multiWorkplaceFields(occ.workplaceIds));
  queueWrite(function(){
    return db.collection('audits').add(data).then(function(ref){
      state.activeAuditId = ref.id;
      state.draftAudit = Object.assign({id:ref.id}, data);
      state.collapsedGroups = new Set();
      state.view = 'audit';
      saveDraftBackup();
      render();
    });
  });
};
App.resumeAudit = function(id){
  var a = state.audits.get(id);
  if(!a) return;
  if(!isMyOpenAudit(a)){ showToast('V cizím rozpracovaném auditu nelze pokračovat.'); return; }
  if(openAuditRemainingMs(a)<=0){ showToast('Audit nebyl dokončen do '+openAuditTtlHours()+' hodin od zahájení a byl zrušen.'); render(); return; }
  state.activeAuditId = id;
  var serverCopy = JSON.parse(JSON.stringify(a));
  var backup = loadDraftBackup(id);
  // Prefer the local backup only if it's at least as far along as what's on
  // the server — it exists specifically to cover answers the server never
  // received, but the server copy wins if it turns out to be further ahead
  // (e.g. another device picked up this same audit since the crash).
  var useBackup = backup && countAnsweredResults(backup.answers) + (backup.findings||[]).length >= countAnsweredResults(serverCopy.answers) + (serverCopy.findings||[]).length;
  state.draftAudit = Object.assign({id:id}, useBackup ? backup : serverCopy);
  state.collapsedGroups = new Set();
  state.auditParticipantsEditing = false;
  if(useBackup){
    showToast('Obnoveny neuložené odpovědi z tohoto telefonu.');
    persistDraft(); // try pushing the recovered answers to the server right away
  }
  render();
};
App.exitRunner = function(){
  state.activeAuditId = null;
  state.draftAudit = null;
  state.auditParticipantsEditing = false;
  render();
};
App.cancelAudit = function(id){
  if(!db) return;
  var ca = state.audits.get(id);
  // Vlastní rozpracovaný audit smí zrušit každý, cizí jen Administrátor.
  if(ca && !isMyOpenAudit(ca) && myRole()!=='administrator') return;
  queueWrite(function(){ return db.doc('audits/'+id).delete(); });
  clearDraftBackup(id);
  if(state.activeAuditId === id){
    state.activeAuditId = null;
    state.draftAudit = null;
  }
  state.confirmTarget = '';
  showToast('Audit zrušen.');
  render();
};
// ---------- local safety net for a running audit ----------
// Every change to the running audit is sent to Supabase immediately, but
// that send can fail (dead zone in a warehouse, flaky mobile signal) or
// never get the chance to run (the browser is killed, the tab is closed,
// the phone's battery dies) before it succeeds. Until now a failed/unsent
// change just vanished — the audit only ever lived in memory. Mirroring it
// into localStorage on every change means the in-progress answers survive
// a crash/close/reload and get offered back when the auditor resumes.
var DRAFT_BACKUP_KEY = 'audit_app_draft_backup_v1';
function saveDraftBackup(){
  if(!state.draftAudit) return;
  try{
    localStorage.setItem(DRAFT_BACKUP_KEY, JSON.stringify({
      id: state.draftAudit.id,
      savedAt: new Date().toISOString(),
      audit: state.draftAudit
    }));
  }catch(e){ /* storage full/unavailable — nothing more we can do locally */ }
}
function loadDraftBackup(id){
  try{
    var raw = localStorage.getItem(DRAFT_BACKUP_KEY);
    if(!raw) return null;
    var parsed = JSON.parse(raw);
    return (parsed && parsed.id === id) ? parsed.audit : null;
  }catch(e){ return null; }
}
function clearDraftBackup(id){
  try{
    var raw = localStorage.getItem(DRAFT_BACKUP_KEY);
    if(!raw) return;
    var parsed = JSON.parse(raw);
    if(!id || (parsed && parsed.id === id)) localStorage.removeItem(DRAFT_BACKUP_KEY);
  }catch(e){ try{ localStorage.removeItem(DRAFT_BACKUP_KEY); }catch(e2){} }
}
function countAnsweredResults(answers){
  var n = 0;
  (answers||[]).forEach(function(ans){
    if(ans.result) n++;
    (ans.subAnswers||[]).forEach(function(sa){ if(sa.result) n++; });
  });
  return n;
}
function persistDraft(){
  saveDraftBackup();
  if(!db || !state.draftAudit) return;
  var id = state.draftAudit.id;
  var answers = state.draftAudit.answers;
  var findings = state.draftAudit.findings || [];
  queueWrite(function(){ return db.doc('audits/'+id).update({answers: answers, findings: findings}); });
}
App.toggleParticipantsEdit = function(){
  state.auditParticipantsEditing = !state.auditParticipantsEditing;
  render();
};
// ---------- zúčastněné osoby = spoluauditoři (rozhodnutí uživatele 2026-10-29) ----------
// Uživatelé aplikace s přístupem k firmě se vybírají ze seznamu (participantIds
// — audit pak vidí ve svých auditech a termín plánu se jim počítá jako splněný),
// lidé bez účtu se dopíšou jménem. participants = jména všech (detail, PDF, CSV).
// key: 'new' (formulář zahájení, state.newAuditPeople) | 'draft' (probíhající audit).
function participantPeople(key){
  if(key==='new') return state.newAuditPeople || (state.newAuditPeople = []);
  var a = state.draftAudit || {};
  var ids = a.participantIds || [];
  var people = ids.map(function(id){ return {id:id, name:personDisplayName(id)}; });
  var userNames = people.map(function(p){ return p.name; });
  (a.participants||[]).forEach(function(n){
    var i = userNames.indexOf(n);
    if(i>=0) userNames.splice(i, 1); else people.push({id:null, name:n});
  });
  return people;
}
function setParticipantPeople(key, people){
  if(key==='new'){ state.newAuditPeople = people; return; }
  var a = state.draftAudit;
  if(!a) return;
  a.participants = people.map(function(p){ return p.name; });
  a.participantIds = people.filter(function(p){ return p.id; }).map(function(p){ return p.id; });
  a.participantAbsent = (a.participantAbsent||[]).filter(function(id){ return a.participantIds.indexOf(id)>=0; });
  saveDraftBackup();
  if(db){
    var id = a.id, upd = {participants:a.participants, participantIds:a.participantIds, participantAbsent:a.participantAbsent};
    queueWrite(function(){ return db.doc('audits/'+id).update(upd); });
  }
}
function participantCompanyId(key){
  if(key==='draft') return (state.draftAudit && state.draftAudit.companyId) || state.currentCompanyId || '';
  var wp = state.workplaces.get(state.newAuditWp);
  return (wp && wp.companyId) || state.currentCompanyId || '';
}
// Uživatelé s přístupem k firmě, bez auditora a už vybraných.
function participantCandidates(key, query){
  var cid = participantCompanyId(key);
  var auditorId = key==='draft' ? (state.draftAudit && state.draftAudit.auditorId) : state.myId;
  var taken = {};
  participantPeople(key).forEach(function(p){ if(p.id) taken[p.id] = true; });
  var q = normalizeSearchText(query||'').trim();
  var out = [];
  state.roles.forEach(function(r, id){
    if(id===auditorId || taken[id] || !state.profiles.has(id) || !roleHasCompany(r, cid)) return;
    var name = personDisplayName(id), email = (state.profiles.get(id).email||'');
    if(q && normalizeSearchText(name+' '+email).indexOf(q)<0) return;
    out.push({id:id, name:name});
  });
  return out.sort(function(a,b){ return a.name.localeCompare(b.name, 'cs'); }).slice(0, 8);
}
function participantsPickerHtml(key){
  var people = participantPeople(key);
  return (people.length ? '<div class="pp-chips">' + people.map(function(p, i){
      return '<span class="sched-chip">'+esc(p.name)+(p.id ? '' : ' <span class="muted" style="font-size:var(--fs-xs)">bez účtu</span>') +
        '<button type="button" title="Odebrat" aria-label="Odebrat '+esc(p.name)+'" onclick="App.ppRemove(\''+key+'\','+i+')">×</button></span>';
    }).join('') + '</div>' : '') +
    '<div class="rp-combo-wrap" style="position:relative">' +
    '<input id="ppInput_'+key+'" placeholder="Hledat uživatele nebo napsat jméno" autocomplete="off" ' +
    'oninput="App.ppRefresh(\''+key+'\')" onfocus="App.ppRefresh(\''+key+'\')" ' +
    'onkeydown="if(event.key===\'Enter\'){event.preventDefault();App.ppAddTyped(\''+key+'\');}" ' +
    'onblur="App.hideResponsibleDropdown(\'ppList_'+key+'\')"/>' +
    '<div id="ppList_'+key+'" class="rp-combo-list" style="display:none"></div></div>' +
    '<div class="muted" style="font-size:var(--fs-sm);margin-top:5px">Vybraní uživatelé uvidí audit ve svých auditech. Lidi bez účtu stačí napsat.</div>';
}
// Docházka zúčastněného (jen účty): nepřítomný se nepočítá jako spoluauditor.
App.setAttendance = function(userId, present){
  var a = state.draftAudit;
  if(!a) return;
  var list = (a.participantAbsent||[]).filter(function(x){ return x!==userId; });
  if(!present) list.push(userId);
  a.participantAbsent = list;
  saveDraftBackup();
  if(db){ var id = a.id; queueWrite(function(){ return db.doc('audits/'+id).update({participantAbsent:list}); }); }
  render();
};
App.ppRefresh = function(key){
  var input = document.getElementById('ppInput_'+key), dd = document.getElementById('ppList_'+key);
  if(!input || !dd) return;
  var typed = input.value.trim();
  var list = participantCandidates(key, typed);
  var html = list.map(function(c){
    return '<button type="button" class="rp-combo-item" onmousedown="event.preventDefault();App.ppAddUser(\''+key+'\',\''+c.id+'\')">'+esc(c.name)+'</button>';
  }).join('');
  if(typed) html += '<button type="button" class="rp-combo-item" onmousedown="event.preventDefault();App.ppAddTyped(\''+key+'\')">+ Přidat „'+esc(typed)+'“ (bez účtu)</button>';
  if(!html) html = '<div style="padding:9px 12px;font-size:var(--fs-sm);color:var(--fg-muted)">Napište jméno.</div>';
  dd.innerHTML = html;
  dd.style.display = 'block';
};
function ppAfterChange(key){
  render();
  var input = document.getElementById('ppInput_'+key);
  if(input){ input.focus(); App.ppRefresh(key); }
}
App.ppAddUser = function(key, id){
  var people = participantPeople(key).slice();
  if(people.some(function(p){ return p.id===id; })) return;
  people.push({id:id, name:personDisplayName(id)});
  setParticipantPeople(key, people);
  ppAfterChange(key);
};
App.ppAddTyped = function(key){
  var input = document.getElementById('ppInput_'+key);
  var name = input ? input.value.trim().replace(/\s+/g,' ') : '';
  if(!name) return;
  var people = participantPeople(key).slice();
  if(!people.some(function(p){ return p.name.toLowerCase()===name.toLowerCase(); })) people.push({id:null, name:name});
  setParticipantPeople(key, people);
  ppAfterChange(key);
};
App.ppRemove = function(key, idx){
  var people = participantPeople(key).slice();
  people.splice(idx, 1);
  setParticipantPeople(key, people);
  render();
};
function allResultItems(answers){
  var out = [];
  (answers||[]).forEach(function(ans){
    out.push(ans.result);
    (ans.subAnswers||[]).forEach(function(sa){ out.push(sa.result); });
  });
  return out;
}
// Item-level success rate for a single closed audit: ok/(ok+nok)*100, ignoring
// N/A. Returns null when there's nothing to score (no OK/NOK items at all),
// so callers can show "—" instead of a misleading 0% or 100%.
// Hodnocení podle druhu auditu (Nastavení → Druhy auditů → Hodnocení):
//  nokThreshold — audit je NOK od tohoto počtu NOK otázek (výchozí 1);
//    uplatní se při uzavření a uloží do summary (uzavřené se nepřepočítávají),
//  evaluation — 'both' | 'okNok' | 'percent' | 'none': co se u auditu
//    zobrazuje a do jakých statistik se počítá (platí hned i pro starší
//    audity). Obchůzka (auditMode 'findings') je vždy bez hodnocení.
var AUDIT_EVAL_LABELS = {both:'OK/NOK i procenta', okNok:'Jen OK/NOK', percent:'Jen procenta', none:'Bez hodnocení'};
function auditTypeEval(typeId){
  var t = (typeId && state.auditTypes.get(typeId)) || {};
  var th = parseInt(t.nokThreshold, 10);
  var mode = isFindingsType(t) ? 'none' : (AUDIT_EVAL_LABELS[t.evaluation] ? t.evaluation : 'both');
  return {threshold: th>=1 ? th : defaultNokThreshold(), ownThreshold: th>=1, mode: mode};
}
function auditUsesOkNok(a){ var m = auditTypeEval(a && a.auditTypeId).mode; return m==='both' || m==='okNok'; }
function auditUsesPercent(a){ var m = auditTypeEval(a && a.auditTypeId).mode; return m==='both' || m==='percent'; }
// Způsob auditu (rozhodnutí uživatele 2026-10-29): 'questions' (výchozí)
// nebo 'findings' = obchůzka jen s volnými zjištěními, bez otázek.
function isFindingsType(t){ return !!t && t.auditMode==='findings'; }
function isFindingsTypeId(typeId){ return isFindingsType(typeId && state.auditTypes.get(typeId)); }
function auditScorePercent(a){
  var s = a && a.summary;
  if(!s) return null;
  var denom = (s.ok||0) + (s.nok||0);
  if(denom===0) return null;
  return Math.round((s.ok||0) / denom * 100);
}
// Color thresholds for the % success score. Each audit type may define its
// own ("Vlastní barevná škála"); when it doesn't, the shared global default
// (Nastavení → Hodnocení %) applies. Never affects the Dashboard's separate
// monthly trend chart, which keeps its own fixed 80/50 scale.
function scoreThresholdsForType(typeId){
  var t = typeId ? state.auditTypes.get(typeId) : null;
  if(t && typeof t.scoreGood==='number' && typeof t.scoreBad==='number'){
    return {good:t.scoreGood, bad:t.scoreBad};
  }
  return state.scoreDefaults || SCORE_FACTORY_DEFAULT;
}
function scorePercentColor(pct, thresholds){
  if(pct==null) return 'var(--fg-muted)';
  var th = thresholds || state.scoreDefaults || SCORE_FACTORY_DEFAULT;
  return pct>=th.good ? 'var(--ok)' : (pct<th.bad ? 'var(--nok)' : 'var(--na)');
}
// Colorblind-friendly mode (Nastavení → Vzhled) adds one of these symbols
// next to a colored % score, so the good/borderline/bad zone doesn't rely
// on distinguishing green from red/amber by color alone.
var SCORE_ZONE_SYMBOLS = {good:'✓', warn:'●', bad:'✕'};
function scorePercentZoneSymbol(pct, thresholds){
  if(pct==null) return '';
  var th = thresholds || state.scoreDefaults || SCORE_FACTORY_DEFAULT;
  return pct>=th.good ? SCORE_ZONE_SYMBOLS.good : (pct<th.bad ? SCORE_ZONE_SYMBOLS.bad : SCORE_ZONE_SYMBOLS.warn);
}
function scorePercentHtml(a, opts){
  opts = opts || {};
  var pct = auditScorePercent(a);
  if(pct==null) return '';
  var th = scoreThresholdsForType(a && a.auditTypeId);
  var size = opts.size || '11.5px';
  var symbol = appearance.colorblindMode ? ' <span aria-hidden="true">'+scorePercentZoneSymbol(pct, th)+'</span>' : '';
  return '<span class="mono" style="font-weight:700;font-size:'+size+';color:'+scorePercentColor(pct, th)+'">'+pct+' %'+symbol+'</span>';
}
function groupedDraftAnswers(){
  var groups = [];
  var byGroup = new Map();
  (state.draftAudit.answers||[]).forEach(function(ans){
    if(!byGroup.has(ans.groupId)){
      byGroup.set(ans.groupId, {groupId:ans.groupId, groupName:ans.groupName, items:[]});
      groups.push(byGroup.get(ans.groupId));
    }
    byGroup.get(ans.groupId).items.push(ans);
  });
  return groups;
}
// ---------- corrective actions (entered during the audit, read-only once closed) ----------
function correctiveActionComplete(ca){
  // Osoba bez účtu: jméno i příjmení povinné.
  if(ca && ca.responsibleExternal && !((ca.responsibleFirst||'').trim() && (ca.responsibleLast||'').trim())) return false;
  return !!(ca && ca.description && ca.description.trim() && ca.responsible && ca.responsible.trim() && ca.dueDate);
}
function missingCorrectiveCount(answers){
  var n = 0;
  (answers||[]).forEach(function(ans){
    if(ans.result==='NOK' && !correctiveActionComplete(ans.correctiveAction)) n++;
    (ans.subAnswers||[]).forEach(function(sa){
      if(sa.result==='NOK' && !correctiveActionComplete(sa.correctiveAction)) n++;
    });
  });
  return n;
}
function correctiveInlineFormHtml(ansId, subId, action, forFinding, hint){
  var ca = action || {};
  var idArgs = subId ? ("'"+ansId+"','"+subId+"'") : ("'"+ansId+"',null");
  var comboSuffix = ansId + (subId ? ('_'+subId) : '_x');
  return '<div class="corr-inline">' +
    '<div class="corr-inline-title">Nápravné opatření (povinné)</div>' +
    (hint ? '<div class="set-note" style="margin:0 0 10px">'+esc(hint)+'</div>' : '') +
    '<div class="field"><label>Co je potřeba udělat'+(forFinding?' (nepovinné)':'')+'</label><textarea rows="2" placeholder="'+(forFinding?'Bez vyplnění se použije popis neshody':'Popis opatření…')+'" ' +
      'oninput="App.setCorrectiveFieldLocal('+idArgs+',\'description\',this.value)" onblur="App.persistCorrectiveField()">'+esc(ca.description||'')+'</textarea></div>' +
    '<div class="field-row">' +
    '<div class="field" style="flex:1"><label for="respSel_'+comboSuffix+'">Odpovědná osoba</label>' +
      '<select id="respSel_'+comboSuffix+'" onchange="App.setCorrectiveResponsible('+idArgs+',this.value)">'+responsibleUserOptionsHtml(ca.responsibleId||'', null, {external:true, externalSelected:!!ca.responsibleExternal})+'</select>' +
    '</div>' +
    '<div class="field field-date"><label>Termín</label><div class="date-wrap">'+dateTimeInputHtml({value:ca.dueDate, onChange:'App.setCorrectiveDueDate('+idArgs+',this.value)'}) +
      '</div></div>' +
    '</div>' +
    (ca.responsibleExternal ? externalResponsibleFieldsHtml(ca.responsibleFirst, ca.responsibleLast, 'App.setCorrectiveExternalName('+idArgs+',', 'App.persistCorrectiveField()', 'respExt_'+comboSuffix) : '') +
    '</div>';
}
App.hideResponsibleDropdown = function(domId){
  var dd = document.getElementById(domId);
  if(dd) dd.style.display = 'none';
};
// Odpovědná osoba opatření = uživatel (responsibleId + jméno v responsible).
// Nebo osoba bez účtu (rozhodnutí uživatele 2026-11-03): responsibleExternal +
// jméno/příjmení zapsané ručně, nikde se neeviduje (jen u tohoto opatření).
App.setCorrectiveResponsible = function(ansId, subId, userId){
  var ca = correctiveTarget(ansId, subId), wasExt = !!(ca && ca.responsibleExternal);
  if(userId===EXTERNAL_RESPONSIBLE){
    App.setCorrectiveFieldLocal(ansId, subId, 'responsibleExternal', true);
    App.setCorrectiveFieldLocal(ansId, subId, 'responsibleId', '');
    var c = correctiveTarget(ansId, subId);
    App.setCorrectiveFieldLocal(ansId, subId, 'responsible', ((c.responsibleFirst||'').trim()+' '+(c.responsibleLast||'').trim()).trim());
  } else {
    App.setCorrectiveFieldLocal(ansId, subId, 'responsibleExternal', undefined);
    App.setCorrectiveFieldLocal(ansId, subId, 'responsibleFirst', undefined);
    App.setCorrectiveFieldLocal(ansId, subId, 'responsibleLast', undefined);
    App.setCorrectiveFieldLocal(ansId, subId, 'responsibleId', userId||'');
    App.setCorrectiveFieldLocal(ansId, subId, 'responsible', userNameById(userId));
  }
  persistDraft();
  if(wasExt !== (userId===EXTERNAL_RESPONSIBLE)) render(); // ukázat / skrýt pole jména
};
App.setCorrectiveExternalName = function(ansId, subId, part, val){
  App.setCorrectiveFieldLocal(ansId, subId, part==='first' ? 'responsibleFirst' : 'responsibleLast', val);
  var c = correctiveTarget(ansId, subId);
  App.setCorrectiveFieldLocal(ansId, subId, 'responsible', ((c.responsibleFirst||'').trim()+' '+(c.responsibleLast||'').trim()).trim());
};
function correctiveTarget(ansId, subId){
  var ans = state.draftAudit && draftItem(ansId);
  if(!ans) return null;
  var target = subId ? (ans.subAnswers||[]).find(function(x){ return x.id===subId; }) : ans;
  return target ? target.correctiveAction : null;
}
// Nové opatření: odpovědná osoba předvyplněná z pracoviště.
function defaultCorrectiveAction(wpId){
  var uid0 = responsiblePersonForWorkplace(wpId);
  return {description:'', responsible: userNameById(uid0), responsibleId: uid0, dueDate:''};
}
App.setCorrectiveFieldLocal = function(ansId, subId, field, val){
  if(!state.draftAudit) return;
  var ans = draftItem(ansId);
  if(!ans) return;
  var target = subId ? (ans.subAnswers||[]).find(function(x){ return x.id===subId; }) : ans;
  if(!target) return;
  if(!target.correctiveAction) target.correctiveAction = defaultCorrectiveAction(state.draftAudit.workplaceId);
  if(val===undefined) delete target.correctiveAction[field]; else target.correctiveAction[field] = val;
  refreshAuditCloseFoot();
};
App.persistCorrectiveField = function(){
  persistDraft();
};
// Termín opatření: reaguje na input i change — "Vymazat" ve výběru data na
// iOS pošle jen input. Bez render() (překreslení by zavřelo otevřený výběr
// data), jen uložení rozpracovaného auditu.
App.setCorrectiveDueDate = function(ansId, subId, val){
  var ans = state.draftAudit && draftItem(ansId);
  var target = ans && (subId ? (ans.subAnswers||[]).find(function(x){ return x.id===subId; }) : ans);
  if(target && target.correctiveAction && (target.correctiveAction.dueDate||'')===(val||'')) return;
  App.setCorrectiveFieldLocal(ansId, subId, 'dueDate', val);
  persistDraft();
};
function refreshAuditCloseFoot(){
  if(!state.draftAudit) return;
  var inline = document.getElementById('auditCloseInline');
  if(inline) inline.innerHTML = auditCloseInlineHtml(state.draftAudit);
}
// Pure read-only display for a closed audit: just what was entered, no controls.
// auditId/ansId/subId are optional: when given, this also shows the
// opatření's current status (from the separate correctiveActions store,
// same source the "Opatření" screen uses) as a clickable badge that jumps
// straight to its detail — purely informative here, never included in the
// generated PDF (buildAuditPrintHtml/buildCorrectiveItemPrintHtml don't
// call this function, so the PDF output is unaffected by this).
function correctiveReadOnlyHtml(action, auditId, ansId, subId){
  var has = !!(action && (action.description || action.responsible || action.dueDate));
  if(!has) return '';
  var statusHtml = '';
  if(auditId && ansId){
    var key = correctiveKey(auditId, ansId, subId);
    var rec = state.correctiveActions.get(key);
    var status = rec ? (rec.status||'v_reseni') : 'v_reseni';
    statusHtml = '<button type="button" style="background:none;border:none;padding:0;cursor:pointer" ' +
      'title="Otevřít detail opatření" onclick="event.stopPropagation();App.openCorrectiveDetail(\''+key+'\',{view:\'history\',historyDetailId:\''+auditId+'\'})">' +
      correctiveStatusBadgeHtml(status) + '</button>';
  }
  return '<div style="margin-top:8px;padding:10px;border-radius:8px;background:rgba(127,127,127,.07);border:1px dashed var(--border)">' +
    '<div class="row-between" style="align-items:center;margin-bottom:2px">' +
    '<div style="font-size:var(--fs-sm);color:var(--fg-muted);font-weight:600">NÁPRAVNÉ OPATŘENÍ'+(auditId && ansId ? (function(c){ return c ? ' '+correctiveCodeHtml(c) : ''; })(correctiveCodeOf(state.audits.get(auditId), ansId, subId)) : '')+'</div>' + statusHtml + '</div>' +
    '<div style="font-size:var(--fs-md)">'+esc(action.description||'—')+'</div>' +
    '<div class="muted" style="font-size:var(--fs-sm);margin-top:3px">'+(action.responsible?responsibleLabelHtml(action.responsible, action.responsibleExternal):'bez odpovědné osoby')+(action.dueDate?' · termín '+fmtDateShort(action.dueDate):'')+'</div>' +
    '</div>';
}
// ---------- volná zjištění (rozhodnutí uživatele 2026-10-29) ----------
// a.findings[]: neshoda (result 'NOK', opatření s odpovědnou osobou
// a termínem) nebo dobrá praxe (result 'GOOD'). Každé má vlastní pracoviště
// (výchozí = pracoviště auditu). Obchůzka (auditMode 'findings') má jen je,
// audit podle otázek je má navíc pod otázkami.
// Položka rozpracovaného auditu podle id: odpověď na otázku, nebo zjištění.
function draftItem(id){
  var a = state.draftAudit;
  if(!a) return null;
  return (a.answers||[]).find(function(x){ return x.id===id; }) || (a.findings||[]).find(function(x){ return x.id===id; }) || null;
}
function findingsCountText(findings){
  var nok = 0, good = 0;
  (findings||[]).forEach(function(f){ if(f.result==='GOOD') good++; else nok++; });
  if(!nok && !good) return 'bez zjištění';
  var bits = [];
  if(nok) bits.push(nok+' '+(nok===1?'neshoda':nok<=4?'neshody':'neshod'));
  if(good) bits.push(good+' dobrá praxe');
  return bits.join(' · ');
}
function findingComplete(f){
  if(!(f.note && f.note.trim()) && !(f.result==='GOOD' && f.attachments && f.attachments.length)) return false;
  if(f.result==='GOOD') return true;
  var ca = f.correctiveAction || {};
  return !!(ca.responsible && ca.responsible.trim() && ca.dueDate);
}
function incompleteFindingsCount(findings){
  return (findings||[]).filter(function(f){ return !findingComplete(f); }).length;
}
function workplaceResponsibleName(wpId){ return userNameById(responsiblePersonForWorkplace(wpId)); }
App.addFinding = function(kind){
  var a = state.draftAudit;
  if(!a) return;
  var wp = state.workplaces.get(a.workplaceId) || {};
  var f = {id: uid('f'), result: kind==='good' ? 'GOOD' : 'NOK', note:'', attachments:[],
    workplaceId: a.workplaceId, workplaceName: workplaceLabel(wp) || a.workplaceName || '',
    branchId: a.branchId || '', branchName: a.branchName || 'Sídlo firmy', createdAt: new Date().toISOString()};
  if(f.result==='NOK') f.correctiveAction = defaultCorrectiveAction(a.workplaceId);
  a.findings = (a.findings||[]).concat([f]);
  state.scrollToFindingId = f.id;
  persistDraft();
  render();
};
App.setFindingKind = function(id, kind){
  var f = draftItem(id);
  if(!f || typeof f.questionText==='string') return;
  f.result = kind==='good' ? 'GOOD' : 'NOK';
  if(f.result==='NOK' && !f.correctiveAction) f.correctiveAction = defaultCorrectiveAction(f.workplaceId);
  persistDraft();
  render();
};
App.setFindingWorkplace = function(id, wpId){
  var f = draftItem(id), wp = state.workplaces.get(wpId);
  if(!f || !wp) return;
  var prevRp = responsiblePersonForWorkplace(f.workplaceId);
  f.workplaceId = wpId; f.workplaceName = workplaceLabel(wp);
  f.branchId = wp.branchId || ''; f.branchName = branchLabel(wp.branchId);
  // Odpovědná osoba předvyplněná z pracoviště se změní s pracovištěm.
  if(f.correctiveAction && (!f.correctiveAction.responsibleId || f.correctiveAction.responsibleId===prevRp)){
    var nd = defaultCorrectiveAction(wpId);
    f.correctiveAction.responsibleId = nd.responsibleId; f.correctiveAction.responsible = nd.responsible;
  }
  persistDraft();
  render();
};
App.removeFinding = function(id){
  var a = state.draftAudit;
  if(!a) return;
  var f = (a.findings||[]).find(function(x){ return x.id===id; });
  a.findings = (a.findings||[]).filter(function(x){ return x.id!==id; });
  state.confirmTarget = '';
  persistDraft();
  render();
  if(f && assetsCap) (f.attachments||[]).forEach(function(att){ assetsCap.delete(att.id).catch(function(){}); });
};
function findingCardHtml(f, idx){
  var good = f.result==='GOOD';
  var confirm = confirmRow('finding:'+f.id, 'Smazat toto zjištění?', 'Smazat', 'btn-danger');
  var html = '<div class="q-card finding-card '+(good?'st-ok':'st-nok')+'" id="fnd_'+f.id+'">';
  html += '<div class="row-between" style="align-items:center;gap:8px;margin-bottom:8px">' +
    '<div class="finding-no">Zjištění '+(idx+1)+'</div>' +
    '<button class="icon-btn" title="Smazat zjištění" onclick="App.askConfirm(\'finding:'+f.id+'\', function(){App.removeFinding(\''+f.id+'\')})">'+ICONS.trash+'</button></div>';
  if(confirm) html += '<div style="margin-bottom:8px">'+confirm+'</div>';
  html += '<div class="seg seg-2">' +
    '<button class="'+(good?'':'sel-nok')+'" onclick="App.setFindingKind(\''+f.id+'\',\'nok\')">Neshoda</button>' +
    '<button class="'+(good?'sel-ok':'')+'" onclick="App.setFindingKind(\''+f.id+'\',\'good\')">Dobrá praxe</button></div>';
  // Obchůzka přes víc pracovišť: pracoviště zjištění jen z auditovaných.
  var auditWps = (state.draftAudit && Array.isArray(state.draftAudit.workplaceIds) && state.draftAudit.workplaceIds.length>1) ? state.draftAudit.workplaceIds : null;
  if(auditWps){
    html += '<div class="field" style="margin:10px 0 0"><label>Pracoviště</label><select onchange="App.setFindingWorkplace(\''+f.id+'\', this.value)">' +
      auditWps.map(function(id){ var w = state.workplaces.get(id); return w ? '<option value="'+id+'" '+(id===f.workplaceId?'selected':'')+'>'+esc(workplaceLabel(w))+'</option>' : ''; }).join('') + '</select></div>';
  } else if(sortedWorkplaces().length>1){
    html += '<div class="field" style="margin:10px 0 0"><label>Pracoviště</label><select onchange="App.setFindingWorkplace(\''+f.id+'\', this.value)">' +
      groupWorkplacesByBranch().map(function(g){
        return '<optgroup label="'+esc(g.label)+'">' + g.items.map(function(e){ return '<option value="'+e[0]+'" '+(e[0]===f.workplaceId?'selected':'')+'>'+esc(workplaceLabel(e[1]))+'</option>'; }).join('') + '</optgroup>';
      }).join('') + '</select></div>';
  }
  html += '<div class="field" style="margin:10px 0 0"><label>'+(good?'Co je dobře':'Popis neshody')+'</label>' +
    '<textarea rows="2" placeholder="'+(good?'Co stojí za to ocenit nebo přenést jinam…':'Co je špatně a kde přesně…')+'" oninput="App.setNoteLocal(\''+f.id+'\', this.value)" onblur="App.persistNote()">'+esc(f.note||'')+'</textarea></div>';
  html += '<div class="q-extra"><label class="photo-add" title="Přidat fotku">'+ICONS.camera +
    '<input type="file" accept="image/*" capture="environment" multiple style="display:none" onchange="App.handlePhoto(event,\''+f.id+'\')"/></label></div>';
  if(f.attachments && f.attachments.length){
    html += '<div class="photo-row">' + f.attachments.map(function(att){
      return '<div class="photo-thumb"><img loading="lazy" decoding="async" src="'+att.url+'" onclick="App.viewPhoto(\''+att.url+'\')"/>' +
        '<button class="rm" onclick="App.removePhoto(\''+f.id+'\',\''+att.id+'\')">×</button></div>';
    }).join('') + '</div>';
  }
  if(!good) html += correctiveInlineFormHtml(f.id, null, f.correctiveAction, true,
    workplaceResponsibleName(f.workplaceId) ? '' : 'Pracoviště nemá odpovědnou osobu – vyberte, kdo neshodu vyřeší.');
  html += '</div>';
  return html;
}
function findingsSectionHtml(a){
  var list = a.findings || [];
  var gemba = isFindingsTypeId(a.auditTypeId);
  var html = '<div class="set-section">'+(gemba ? 'Zjištění' : 'Volná zjištění')+(list.length ? ' ('+list.length+')' : '')+'</div>';
  if(!list.length){
    html += '<div class="set-note" style="margin:0 0 10px">'+(gemba ?
      'Projděte pracoviště a zapište, co najdete: neshodu s fotkou, odpovědnou osobou a termínem, nebo dobrou praxi.' :
      'Neshoda nebo dobrá praxe, na kterou se otázky neptají.')+'</div>';
  }
  list.forEach(function(f, i){ html += findingCardHtml(f, i); });
  html += '<div class="finding-add-row">' +
    '<button class="btn '+(gemba?'btn-primary':'')+'" onclick="App.addFinding(\'nok\')">+ Neshoda</button>' +
    '<button class="btn" onclick="App.addFinding(\'good\')">+ Dobrá praxe</button></div>';
  return html;
}
function renderAuditRunner(){
  var a = state.draftAudit;
  // Po lhůtě (výchozí 24 h) od zahájení se rozpracovaný audit ruší (server ho smaže).
  if(openAuditRemainingMs(a)<=0){
    clearDraftBackup(a.id);
    state.activeAuditId = null; state.draftAudit = null;
    showToast('Audit nebyl dokončen do '+openAuditTtlHours()+' hodin od zahájení a byl zrušen.');
    renderAudit();
    return;
  }
  var answers = a.answers||[];
  var allItems = allResultItems(answers);
  var total = allItems.length;
  var answered = allItems.filter(Boolean).length;
  var nok = allItems.filter(function(r){return r==='NOK';}).length;
  var pct = total ? Math.round(answered/total*100) : 0;
  var gemba = isFindingsTypeId(a.auditTypeId);
  var fList = a.findings || [];
  var fNok = fList.filter(function(f){ return f.result!=='GOOD'; }).length;

  var cancelConfirm = confirmRow('cancelaudit:'+a.id, 'Zrušit tento audit? Všechny odpovědi se ztratí.', 'Zrušit audit', 'btn-danger');
  var html = '<div class="view-head"><div class="row-between" style="margin-bottom:10px;gap:8px">' +
    '<button class="btn btn-sm btn-ghost" onclick="App.exitRunner()">← Zpět</button>' +
    '<button class="btn btn-sm btn-ghost btn-danger" onclick="App.askConfirm(\'cancelaudit:'+a.id+'\', function(){App.cancelAudit(\''+a.id+'\')})">Zrušit audit</button></div>' +
    (cancelConfirm ? '<div style="margin-bottom:10px">'+cancelConfirm+'</div>' : '') +
    '<h2 style="font-size:var(--fs-2xl)">'+esc(a.workplaceName)+'</h2>' +
    '<p>'+esc(a.branchName||'Sídlo firmy')+' · '+esc(a.auditTypeName||'Audit')+' · '+esc(auditAuditorLabel(a))+' · zahájeno '+fmtDateShort(a.startedAt)+'</p></div>';

  // Uzavřít audit je vpravo v této dlaždici, která je přilepená nahoře.
  html += '<div class="card audit-progress-card" id="auditProgressCard" style="margin-bottom:14px"><div class="audit-progress-row">' +
    '<div class="audit-progress-main">' +
    (gemba ? '<span style="font-size:var(--fs-base)">'+findingsCountText(fList)+'</span>' :
      '<span class="mono" style="font-size:var(--fs-base);white-space:nowrap">'+answered+' / '+total+' zodpovězeno</span>' +
      (nok>0 ? '<span class="badge badge-nok" style="white-space:nowrap">'+nok+' NOK</span>' : (fNok ? '' : '<span class="badge badge-ok" style="white-space:nowrap">bez závad</span>')) +
      (fList.length ? '<span class="badge '+(fNok?'badge-nok':'badge-ok')+'" style="white-space:nowrap">'+fList.length+' zjištění</span>' : '')) +
    '</div>' +
    '<div class="audit-close-inline" id="auditCloseInline">'+auditCloseInlineHtml(a)+'</div></div>' +
    '<div class="audit-ttl" style="font-size:var(--fs-sm);margin-top:6px;'+(openAuditRemainingMs(a)<2*3600000?'color:var(--nok);font-weight:600':'color:var(--fg-muted)')+'">Dokončit do '+openAuditTtlHours()+' h od zahájení · '+openAuditRemainingText(a)+'</div>' +
    (gemba ? '' : '<div class="progress-wrap" style="margin-top:10px"><div class="progress-fill" style="width:'+pct+'%"></div></div>') + '</div>';

  groupedDraftAnswers().forEach(function(grp){
    var collapsed = state.collapsedGroups.has(grp.groupId);
    var grpAll = allResultItems(grp.items);
    var gAnswered = grpAll.filter(Boolean).length;
    var grpNok = grpAll.filter(function(r){return r==='NOK';}).length;
    html += '<div class="group-section">';
    html += '<div class="group-head" onclick="App.toggleGroup(\''+grp.groupId+'\')">' +
      '<div class="title"><span style="transform:rotate('+(collapsed?0:90)+'deg);display:inline-flex;transition:.15s">'+ICONS.chev+'</span>'+esc(grp.groupName)+'</div>' +
      '<div class="right">'+(grpNok>0?'<span class="nokbadge">'+grpNok+' NOK</span>':'')+'<span class="count">'+gAnswered+'/'+grpAll.length+'</span></div></div>';
    if(!collapsed){
      html += '<div class="group-body">';
      grp.items.forEach(function(ans){
        var noteOpen = state.openNotes.has(ans.id);
        var cardCls = ans.result==='OK'?' st-ok':(ans.result==='NOK'?' st-nok':(ans.result==='NA'?' st-na':''));
        html += '<div class="q-card'+cardCls+'">';
        html += '<div class="q-text">'+esc(ans.questionText)+'</div>';
        html += '<div class="seg">' +
          '<button class="'+(ans.result==='OK'?'sel-ok':'')+'" onclick="App.setResult(\''+ans.id+'\',\'OK\')">OK</button>' +
          '<button class="'+(ans.result==='NOK'?'sel-nok':'')+'" onclick="App.setResult(\''+ans.id+'\',\'NOK\')">NOK</button>' +
          '<button class="'+(ans.result==='NA'?'sel-na':'')+'" onclick="App.setResult(\''+ans.id+'\',\'NA\')">N/A</button>' +
          '</div>';
        html += '<div class="q-extra">' +
          '<button class="btn btn-sm btn-ghost" onclick="App.toggleNote(\''+ans.id+'\')">'+(ans.note?'Zjištění ✓':'+ Zjištění')+'</button>' +
          '<label class="photo-add" title="Přidat fotku/přílohu">'+ICONS.camera +
          '<input type="file" accept="image/*" capture="environment" multiple style="display:none" onchange="App.handlePhoto(event,\''+ans.id+'\')"/></label>' +
          '</div>';
        if(noteOpen){
          html += '<textarea placeholder="Zjištění k otázce…" oninput="App.setNoteLocal(\''+ans.id+'\', this.value)" onblur="App.persistNote()">'+esc(ans.note)+'</textarea>';
        }
        if(ans.attachments && ans.attachments.length){
          html += '<div class="photo-row">';
          ans.attachments.forEach(function(att){
            html += '<div class="photo-thumb"><img loading="lazy" decoding="async" src="'+att.url+'" onclick="App.viewPhoto(\''+att.url+'\')"/>' +
              '<button class="rm" onclick="App.removePhoto(\''+ans.id+'\',\''+att.id+'\')">×</button></div>';
          });
          html += '</div>';
        }
        if(ans.result==='NOK'){
          html += correctiveInlineFormHtml(ans.id, null, ans.correctiveAction);
        }
        if(ans.subAnswers && ans.subAnswers.length){
          html += '<div class="subwrap">';
          ans.subAnswers.forEach(function(sa){
            var subNoteOpen = state.openNotes.has(sa.id);
            var subCls = sa.result==='OK'?' st-ok':(sa.result==='NOK'?' st-nok':(sa.result==='NA'?' st-na':''));
            html += '<div class="subcard'+subCls+'">' +
              '<div class="sublabel">Podotázka</div>' +
              '<div class="q-text">'+esc(sa.text)+'</div>' +
              '<div class="seg">' +
              '<button class="'+(sa.result==='OK'?'sel-ok':'')+'" onclick="App.setSubResult(\''+ans.id+'\',\''+sa.id+'\',\'OK\')">OK</button>' +
              '<button class="'+(sa.result==='NOK'?'sel-nok':'')+'" onclick="App.setSubResult(\''+ans.id+'\',\''+sa.id+'\',\'NOK\')">NOK</button>' +
              '<button class="'+(sa.result==='NA'?'sel-na':'')+'" onclick="App.setSubResult(\''+ans.id+'\',\''+sa.id+'\',\'NA\')">N/A</button>' +
              '</div>' +
              '<div class="q-extra">' +
              '<button class="btn btn-sm btn-ghost" onclick="App.toggleSubNote(\''+ans.id+'\',\''+sa.id+'\')">'+(sa.note?'Zjištění ✓':'+ Zjištění')+'</button>' +
              '<label class="photo-add" title="Přidat fotku/přílohu">'+ICONS.camera +
              '<input type="file" accept="image/*" capture="environment" multiple style="display:none" onchange="App.handleSubPhoto(event,\''+ans.id+'\',\''+sa.id+'\')"/></label>' +
              '</div>' +
              (subNoteOpen ? '<textarea placeholder="Zjištění k podotázce…" oninput="App.setSubNoteLocal(\''+ans.id+'\',\''+sa.id+'\', this.value)" onblur="App.persistNote()">'+esc(sa.note)+'</textarea>' : '') +
              ((sa.attachments && sa.attachments.length) ? ('<div class="photo-row">' + sa.attachments.map(function(att){
                return '<div class="photo-thumb"><img loading="lazy" decoding="async" src="'+att.url+'" onclick="App.viewPhoto(\''+att.url+'\')"/>' +
                  '<button class="rm" onclick="App.removeSubPhoto(\''+ans.id+'\',\''+sa.id+'\',\''+att.id+'\')">×</button></div>';
              }).join('') + '</div>') : '') +
              (sa.result==='NOK' ? correctiveInlineFormHtml(ans.id, sa.id, sa.correctiveAction) : '') +
              '</div>';
          });
          html += '</div>';
        }
        html += '</div>';
      });
      html += '</div>';
    }
    html += '</div>';
  });

  html += '<div class="findings-section">' + findingsSectionHtml(a) + '</div>';

  if(state.auditParticipantsEditing){
    html += '<div class="card" style="margin-bottom:14px"><div class="field" style="margin-bottom:8px">' +
      '<label for="ppInput_draft">Zúčastněné osoby</label>' + participantsPickerHtml('draft') + '</div>' +
      '<button class="btn btn-sm btn-primary" onclick="App.toggleParticipantsEdit()">Hotovo</button></div>';
  } else {
    // Docházka: u zúčastněných s účtem Přítomen / Nepřítomen (výchozí přítomen).
    var people = participantPeople('draft'), absent = a.participantAbsent || [];
    html += '<div class="card" style="margin-bottom:14px"><div class="row-between" style="align-items:center;gap:10px">' +
      '<div style="font-weight:600;font-size:var(--fs-base)">Zúčastněné osoby'+(people.length?'':' <span class="muted" style="font-weight:400">—</span>')+'</div>' +
      '<button class="btn btn-sm btn-ghost" onclick="App.toggleParticipantsEdit()">'+ICONS.edit+' Upravit</button></div>';
    people.forEach(function(p){
      var away = p.id && absent.indexOf(p.id)>=0;
      html += '<div class="row-between attendance-row" style="align-items:center;gap:10px;margin-top:8px">' +
        '<span style="min-width:0'+(away?';color:var(--fg-muted);text-decoration:line-through':'')+'">'+esc(p.name)+(p.id?'':' <span class="muted" style="font-size:var(--fs-xs)">bez účtu</span>')+'</span>' +
        (p.id ? '<div class="seg seg-sm" role="group" aria-label="Docházka '+esc(p.name)+'">' +
          '<button class="'+(away?'':'sel-ok')+'" onclick="App.setAttendance(\''+p.id+'\', true)">Přítomen</button>' +
          '<button class="'+(away?'sel-nok':'')+'" onclick="App.setAttendance(\''+p.id+'\', false)">Nepřítomen</button></div>' : '') +
        '</div>';
    });
    html += '</div>';
  }



  document.getElementById('content').innerHTML = html;
  if(state.scrollToFindingId){
    var el = document.getElementById('fnd_'+state.scrollToFindingId);
    state.scrollToFindingId = null;
    if(el && el.scrollIntoView) el.scrollIntoView({block:'center'});
  }
}
// Kompaktní varianta pro dlaždici s průběhem (desktop): jen tlačítko
// vpravo, neaktivní, dokud nejsou vyhodnocené všechny otázky a doplněná
// opatření (bez informačního textu — přání uživatele).
function auditCloseInlineHtml(a){
  var allItems = allResultItems(a.answers);
  var remaining = allItems.length - allItems.filter(Boolean).length;
  var missingCorrective = missingCorrectiveCount(a.answers) + incompleteFindingsCount(a.findings);
  if(remaining>0 || missingCorrective>0){
    return '<button class="btn btn-primary" disabled>Uzavřít audit</button>';
  }
  var confirmClose = confirmRow('close:'+a.id, 'Opravdu uzavřít audit? Výsledky již nepůjde upravit.', 'Uzavřít audit', 'btn-primary', 'neutral');
  if(confirmClose) return confirmClose;
  return '<button class="btn btn-primary" onclick="App.askConfirm(\'close:'+a.id+'\', function(){App.closeAudit()})">Uzavřít audit</button>';
}
App.toggleNote = function(ansId){
  if(state.openNotes.has(ansId)) state.openNotes.delete(ansId); else state.openNotes.add(ansId);
  render();
};
App.setNoteLocal = function(ansId, val){
  var ans = draftItem(ansId);
  if(ans) ans.note = val;
  refreshAuditCloseFoot(); // popis zjištění je povinný
};
App.persistNote = function(){
  persistDraft();
};
App.setResult = function(ansId, val){
  var ans = draftItem(ansId);
  if(!ans) return;
  ans.result = (ans.result===val) ? ans.result : val;
  if(ans.result==='NOK' && !ans.correctiveAction && state.draftAudit) ans.correctiveAction = defaultCorrectiveAction(state.draftAudit.workplaceId);
  // N/A na otázce platí i pro všechny její podotázky — nemá smysl je
  // vyplňovat zvlášť, když se celá otázka netýká daného pracoviště.
  if(ans.result==='NA' && ans.subAnswers && ans.subAnswers.length){
    ans.subAnswers.forEach(function(sa){ sa.result = 'NA'; });
  }
  persistDraft();
  render();
};
App.setSubResult = function(ansId, subId, val){
  var ans = draftItem(ansId);
  if(!ans) return;
  var sa = (ans.subAnswers||[]).find(function(x){return x.id===subId;});
  if(!sa) return;
  sa.result = (sa.result===val) ? sa.result : val;
  if(sa.result==='NOK' && !sa.correctiveAction && state.draftAudit) sa.correctiveAction = defaultCorrectiveAction(state.draftAudit.workplaceId);
  persistDraft();
  render();
};
App.handlePhoto = async function(ev, ansId){
  var files = Array.from(ev.target.files||[]);
  ev.target.value = '';
  if(!files.length || !assetsCap) { if(!assetsCap) showToast('Nahrávání příloh není dostupné.'); return; }
  var ans = draftItem(ansId);
  if(!ans) return;
  for(var i=0;i<files.length;i++){
    try{
      var res = await assetsCap.upload(files[i]);
      ans.attachments = ans.attachments || [];
      ans.attachments.push({id:res.id, url:res.url, contentType:res.contentType});
      persistDraft();
      render();
    }catch(e){
      console.error('upload failed', e);
      showToast(uploadErrorText(e, 'Nahrání fotky se nezdařilo.'));
    }
  }
};
App.removePhoto = function(ansId, attId){
  var ans = draftItem(ansId);
  if(!ans) return;
  ans.attachments = (ans.attachments||[]).filter(function(a){return a.id!==attId;});
  persistDraft();
  render();
  if(assetsCap){ assetsCap.delete(attId).catch(function(){}); }
};
App.toggleSubNote = function(ansId, subId){
  if(state.openNotes.has(subId)) state.openNotes.delete(subId); else state.openNotes.add(subId);
  render();
};
App.setSubNoteLocal = function(ansId, subId, val){
  var ans = draftItem(ansId);
  var sa = ans && (ans.subAnswers||[]).find(function(x){return x.id===subId;});
  if(sa) sa.note = val;
};
App.handleSubPhoto = async function(ev, ansId, subId){
  var files = Array.from(ev.target.files||[]);
  ev.target.value = '';
  if(!files.length || !assetsCap) { if(!assetsCap) showToast('Nahrávání příloh není dostupné.'); return; }
  var ans = draftItem(ansId);
  var sa = ans && (ans.subAnswers||[]).find(function(x){return x.id===subId;});
  if(!sa) return;
  for(var i=0;i<files.length;i++){
    try{
      var res = await assetsCap.upload(files[i]);
      sa.attachments = sa.attachments || [];
      sa.attachments.push({id:res.id, url:res.url, contentType:res.contentType});
      persistDraft();
      render();
    }catch(e){
      console.error('upload failed', e);
      showToast(uploadErrorText(e, 'Nahrání fotky se nezdařilo.'));
    }
  }
};
App.removeSubPhoto = function(ansId, subId, attId){
  var ans = draftItem(ansId);
  var sa = ans && (ans.subAnswers||[]).find(function(x){return x.id===subId;});
  if(!sa) return;
  sa.attachments = (sa.attachments||[]).filter(function(a){return a.id!==attId;});
  persistDraft();
  render();
  if(assetsCap){ assetsCap.delete(attId).catch(function(){}); }
};
App.viewPhoto = function(url){
  var root = document.getElementById('overlayRoot');
  root.innerHTML = '<div class="overlay" onclick="App.closeOverlay(event)"><img src="'+url+'"/>' +
    '<button class="close" onclick="App.closeOverlay(event)">×</button></div>';
};
App.closeOverlay = function(ev){
  if(ev) ev.stopPropagation();
  document.getElementById('overlayRoot').innerHTML = '';
};

export {
  myStartableScheduledOccurrences,
  auditsHeadHtml,
  effectiveAuditTab,
  AUDIT_EVAL_LABELS,
  SCORE_ZONE_SYMBOLS,
  allResultItems,
  auditScorePercent,
  auditTypeEval,
  auditUsesOkNok,
  auditUsesPercent,
  isFindingsType,
  isFindingsTypeId,
  clearDraftBackup,
  correctiveReadOnlyHtml,
  findingsCountText,
  incompleteFindingsCount,
  isScheduleOccurrenceStartableNow,
  missingCorrectiveCount,
  renderAudit,
  scorePercentColor,
  scorePercentHtml,
  scorePercentZoneSymbol,
  scoreThresholdsForType
};
